import React from 'react'
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';

function LazyImage({alt, src, className, height, width, isSvg}) {
  if(isSvg) {
    return (
      <LazyLoadImage
        alt={alt || src}
        src={src}
        height={height}
        width={width}
        className={className}
      />
    )
  }
  return (
    <LazyLoadImage
      alt={alt || src}
      src={src}
      height={height}
      width={width}
      effect="blur"
      className={className}
    />
  )
}

export default LazyImage
